const printPage = () => {
  window.print()
  window.webkit?.messageHandlers.print.postMessage('print')
}
export default printPage
